// extracted by mini-css-extract-plugin
export default {"root":"q3Y0EbpcLLbkZZRjqhy0","placeHolderShimmer":"FvtVzhd3iePTea6F8n57"};